export const CONTACT = {
  email: "sales@medisgroupllp.com",
  phone: "+91 89565 28732",
  phoneInt: "8956528732",
  whatsapp:
    "https://wa.me/919307200259?text=Hi%20MEDIS%20Group%20LLP%2C%20I%27d%20like%20to%20enquire%20about%20your%20medical%20equipment.",
  address: "Block A, Wadki, Taluka Haveli, Pune - 412308, Maharashtra, India",
  dotmedixa: "https://www.dotmedixa.com",
};

export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "Products", href: "#products" },
  { label: "Solutions", href: "#solution" },
  { label: "Sectors", href: "#sectors" },
  { label: "Partners", href: "#partners" },
  { label: "Why Us", href: "#why-choose" },
  { label: "Process", href: "#how-we-work" },
  { label: "Support", href: "#support" },
  { label: "Gallery", href: "#gallery" },
];

export const SLIDES = [
  {
    tag: "MRI Scanners",
    lines: ["Advanced MRI Systems", "for Precise Diagnostics"],
    desc: "High-field 1.5T & 3T MRI scanners sourced, refurbished and deployed across India with full technical support.",
    img: "/c1.jpeg",
    mobileImg: "/cm1.jpeg",
  },
  {
    tag: "CT Scanners",
    lines: ["CT Scan Systems Built", "for High-Volume Centres"],
    desc: "16 to 640-slice CT scanners from Canon, Siemens & GE verified, in-stock and ready for installation.",
    img: "/c2.jpeg",
    mobileImg: "/cm2.jpeg",
  },
  {
    tag: "Cath Lab",
    lines: ["Interventional Imaging", "for Cardiac Facilities"],
    desc: "Complete Cath Lab systems with installation, spare parts and lifecycle maintenance support.",
    img: "/c3.jpeg",
    mobileImg: "/cm3.jpeg",
  },
  {
    tag: "Support & Service",
    lines: ["End-to-End Lifecycle", "Support Across India"],
    desc: "AMC, CMC, helium supply, cryogenic support and spare parts keeping your imaging systems operational.",
    img: "/c4.jpeg",
    mobileImg: "/cm4.jpeg",
  },
];

export const PRODUCT_TABS = [
  { id: "all", label: "All Products" },
  { id: "ct", label: "CT Scanners" },
  { id: "mri", label: "MRI Scanners" },
  { id: "cathlab", label: "Cath Lab" },
  { id: "mammo", label: "Mammography" },
  { id: "ultrasound", label: "Ultrasound" },
];

export const TAB_COLORS = {
  ct: "#185FA5",
  mri: "#1D9E75",
  cathlab: "#9333ea",
  mammo: "#e11d48",
  ultrasound: "#0891b2",
};

export const TAB_BADGES = {
  ct: "CT Scanner",
  mri: "MRI Scanner",
  cathlab: "Cath Lab",
  mammo: "Mammography",
  ultrasound: "Ultrasound",
};

export const ENQUIRY_PRODUCTS = [
  "MRI Scanner",
  "CT Scan System",
  "Cath Lab System",
  "RF Shielding",
  "Helium / Cryogenic Support",
  "Spare Parts & Maintenance",
  "Other",
];

export const INFRA_CARDS = [
  {
    num: "01",
    title: "Helium Filling & Supply",
    desc: "Reliable helium support for MRI systems and other cryogenic applications where continuity matters.",
    accent: "#1D9E75",
  },
  {
    num: "02",
    title: "MRI Magnet Pre-Cooling",
    desc: "Controlled pre-cooling to improve efficiency, reduce thermal stress and support safer commissioning.",
    accent: "#00A2D3",
  },
  {
    num: "03",
    title: "Cold Heads",
    desc: "Cold head supply and replacement to maintain the cryogenic cooling cycle essential for MRI magnet stability.",
    accent: "#185FA5",
  },
  {
    num: "04",
    title: "Compressors & Chillers",
    desc: "Component support for compressors and chillers that sustain the cryogenic environment required for stable MRI performance.",
    accent: "#1A9080",
  },
  {
    num: "05",
    title: "RF Shielding Solutions",
    desc: "Imaging-room infrastructure that protects imaging data integrity and diagnostic quality.",
    accent: "#1D9E75",
  },
];

export const MARQUEE_TAGS = [
  "RF SHIELDING",
  "HELIUM SUPPLY",
  "CRYOGENIC SERVICES",
  "SPARE PARTS",
  "CMC / AMC",
  "SITE PLANNING",
];

export const SECTORS = [
  {
    icon: "building2",
    label: "For Hospitals",
    number: "01",
    tag: "End-to-end supply",
    accent: "#185FA5",
    text: "Integrated imaging solutions for institutions planning new installations, upgrades or long-term infrastructure strengthening. We support procurement, site planning and post-installation maintenance.",
  },
  {
    icon: "scan",
    label: "For Diagnostic Centres",
    number: "02",
    tag: "Workflow continuity",
    accent: "#1D9E75",
    text: "MRI and CT systems supported by technical guidance, parts access, helium support and operational continuity. Designed to keep diagnostic workflows running without interruption.",
  },
  {
    icon: "heartPulse",
    label: "For Cardiac & Interventional Facilities",
    number: "03",
    tag: "Lifecycle coverage",
    accent: "#D4537E",
    text: "Cath lab systems and associated technical support designed to improve workflow and procedural confidence. Full lifecycle coverage from installation to ongoing maintenance and spare parts.",
  },
  {
    icon: "trendingUp",
    label: "For Expansion & Modernization",
    number: "04",
    tag: "Scale-ready support",
    accent: "#00A2D3",
    text: "RF shielding, cryogenic support, installation planning and structured deployment for facilities scaling up. End-to-end support for greenfield builds and equipment upgrades alike.",
  },
];

export const PARTNERS = [
  {
    id: "karnataka",
    name: "Biomed Technology",
    subtitle: "Group of Engineers",
    location: "Karnataka",
    region: "South India",
    description:
      "A specialized biomedical engineering group supporting MRI and imaging equipment across Karnataka with technical expertise and field service capability.",
    services: ["Equipment Servicing", "Technical Support", "Spare Parts"],
    highlights: [
      "15+ years of biomedical field experience",
      "Certified technicians for MRI & CT systems",
      "24/7 emergency breakdown response",
    ],
    since: "2009",
    engineers: "12+",
    coverage: "Karnataka",
  },
  {
    id: "maharashtra1",
    name: "Cryotech",
    subtitle: "Re-inventing Cryogenics",
    location: "Maharashtra",
    region: "West India",
    description:
      "Cryotech is the technology and supply division focused on medical imaging equipment and cryogenic solutions.",
    services: ["Cryogenic Solutions", "Helium Supply", "MRI Equipment"],
    highlights: [
      "Authorised helium supply chain across Maharashtra",
      "Specialised in MRI magnet quench recovery",
      "ISO-certified cryogenic handling procedures",
    ],
    since: "2011",
    engineers: "8+",
    coverage: "Maharashtra",
  },
  {
    id: "uttarpradesh",
    name: "ITS — Imaging Total Support",
    subtitle: "Imaging Total Support",
    location: "Uttar Pradesh",
    region: "North India",
    description:
      "ITS is a specialized service division providing technical expertise, maintenance and operational support for medical imaging systems across Uttar Pradesh.",
    services: ["CMC / AMC Services", "MRI Maintenance", "Technical Expertise"],
    highlights: [
      "Comprehensive AMC/CMC contracts for hospitals",
      "Preventive maintenance scheduling & reporting",
      "Spare parts availability within 48 hrs",
    ],
    since: "2013",
    engineers: "20+",
    coverage: "UP & NCR",
  },
  {
    id: "maharashtra2",
    name: "Telemed Systems",
    subtitle: "TMS",
    location: "Maharashtra",
    region: "West India",
    description:
      "Telemed Systems provides advanced telemedicine and imaging support solutions for hospitals and diagnostic centres.",
    services: ["Telemedicine", "Imaging Support", "Diagnostics"],
    highlights: [
      "Cloud-based DICOM image sharing platform",
      "Remote radiology consultation network",
      "Integrated diagnostic centre management",
    ],
    since: "2015",
    engineers: "10+",
    coverage: "Pune & Mumbai",
  },
  {
    id: "odisha",
    name: "Manoeuvre",
    subtitle: "Medical Solutions",
    location: "Odisha",
    region: "East India",
    description: "Manoeuvre delivers medical equipment solutions and support services across Odisha.",
    services: ["Equipment Supply", "Field Support", "Maintenance"],
    highlights: [
      "Sole authorised distributor in Odisha region",
      "On-site installation & commissioning team",
      "Strong government hospital relationships",
    ],
    since: "2016",
    engineers: "6+",
    coverage: "Odisha",
  },
  {
    id: "rajasthan",
    name: "Viva Imaging Services",
    subtitle: "Imaging Excellence",
    location: "Rajasthan",
    region: "North West India",
    description:
      "Viva Imaging Services operates across Rajasthan providing comprehensive imaging solutions and technical services.",
    services: ["Imaging Services", "Equipment Support", "Technical Training"],
    highlights: [
      "Trained 50+ radiographers across Rajasthan",
      "Sales & service of digital X-ray & ultrasound",
      "Workshop facilities in Jaipur & Jodhpur",
    ],
    since: "2010",
    engineers: "9+",
    coverage: "Rajasthan",
  },
  {
    id: "delhi",
    name: "Mansi Enterprises",
    subtitle: "Medical Equipment",
    location: "Delhi",
    region: "North India",
    description:
      "Mansi Enterprises is a trusted medical equipment partner in Delhi, supplying and supporting imaging and diagnostic systems across NCR.",
    services: ["Equipment Supply", "Installation", "After-Sales Support"],
    highlights: [
      "Serving 100+ hospitals across Delhi NCR",
      "Rapid installation & handover within 72 hrs",
      "Dedicated after-sales relationship managers",
    ],
    since: "2007",
    engineers: "18+",
    coverage: "Delhi NCR",
  },
];

export const WHY_CHOOSE = [
  {
    num: "01",
    title: "Sales-First, Support-Backed",
    text: "We do not just supply imaging equipment we provide the ecosystem that helps it perform reliably over time.",
  },
  {
    num: "02",
    title: "End-to-End Imaging Capability",
    text: "MRI and CT systems, helium, shielding, parts and maintenance the elements required for stable imaging operations in one place.",
  },
  {
    num: "03",
    title: "Technical Depth",
    text: "Experienced engineers, associated support capability and spare parts readiness to reduce uncertainty beyond the initial purchase.",
  },
  {
    num: "04",
    title: "Pan-India Reach",
    text: "Built to support healthcare providers across India practical for hospitals, diagnostic centres and expanding networks.",
  },
  {
    num: "05",
    title: "Lifecycle Reliability",
    text: "Focused on long-term uptime, dependable support and imaging continuity not just one-time equipment supply.",
  },
  {
    num: "06",
    title: "Practical Value",
    text: "We combine sales guidance with technical and operational backing so facilities can make more confident equipment decisions.",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    tag: "Discovery",
    title: "Understand Your Requirement",
    text: "We begin by understanding your clinical needs, facility conditions, project goals and equipment expectations ensuring we recommend the right solution from the start.",
    points: [
      "Site survey & feasibility assessment",
      "Clinical workflow review",
      "Budget & timeline alignment",
      "Regulatory & compliance check",
    ],
  },
  {
    num: "02",
    tag: "Advisory",
    title: "Recommend the Right Solution",
    text: "Based on your requirements, we recommend the right MRI, CT, cath lab, shielding or cryogenic option with full OEM and model comparisons to support your decision.",
    points: [
      "Equipment shortlisting & comparison",
      "OEM & model evaluation",
      "Technical specification matching",
      "Compliance & certification guidance",
    ],
  },
  {
    num: "03",
    tag: "Planning",
    title: "Plan Technical Readiness",
    text: "We align product decisions with installation and support requirements covering civil readiness, shielding design and site preparation to ensure smooth deployment.",
    points: [
      "Site preparation planning",
      "Civil & electrical readiness review",
      "Shielding & layout design",
      "Installation timeline coordination",
    ],
  },
  {
    num: "04",
    tag: "Execution",
    title: "Deliver & Deploy",
    text: "From logistics and customs clearance to OEM-supervised installation and commissioning we coordinate every step of the deployment with precision and accountability.",
    points: [
      "Logistics & customs clearance",
      "OEM-supervised installation",
      "Commissioning & calibration",
      "User handover & documentation",
    ],
  },
  {
    num: "05",
    tag: "Ongoing",
    title: "Support Long-Term Performance",
    text: "Our relationship continues after deployment with spare parts availability, helium and cryogenic servicing and structured AMC/CMC contracts to keep your systems running.",
    points: [
      "CMC / AMC maintenance contracts",
      "Spare parts availability",
      "Helium & cryo servicing",
      "Technical support & uptime management",
    ],
  },
];

export const PROCESS_COLORS = ["#185FA5", "#1a72b8", "#1a9080", "#1D9E75", "#0F6E56"];

export const SUPPORT_CARDS = [
  {
    id: "cmc",
    icon: "clipboard",
    title: "CMC / AMC Services",
    text: "Structured maintenance support to help extend equipment life and reduce unexpected disruptions.",
    accent: "#185FA5",
  },
  {
    id: "spare",
    icon: "package",
    title: "Spare Part Support",
    text: "Ready spare parts to help maintain continuity and minimize avoidable equipment downtime.",
    accent: "#1D9E75",
  },
  {
    id: "installation",
    icon: "hardhat",
    title: "Installation & Site Planning",
    text: "Support for deployment readiness, setup coordination and practical implementation requirements.",
    accent: "#00A2D3",
  },
  {
    id: "imaging",
    icon: "lifebuoy",
    title: "Imaging Total Support (ITS)",
    text: "A specialized service layer for maintenance, technical expertise and ongoing operational assistance.",
    accent: "#185FA5",
  },
];

export const GALLERY_ITEMS = [
  { id: 1, title: "MRI Scanner Suite", category: "Equipment", image: "/MRI Scanner Suite.jpg" },
  { id: 2, title: "CT Scan Installation", category: "Installation", image: "/CT Scan Installation.jpg" },
  { id: 3, title: "Engineering Team at Work", category: "Team", image: "/Engineering Team at Work.jpg" },
  { id: 4, title: "Cryogenic Lab", category: "Infrastructure", image: "/Cryogenic Lab.jpg" },
  { id: 5, title: "Hospital Imaging Centre", category: "Facility", image: "/Hospital Imaging Centre.jpg" },
  { id: 6, title: "Diagnostic Equipment", category: "Equipment", image: "/Diagnostic Equipment.jpg" },
  { id: 7, title: "MRI Control Room", category: "Facility", image: "/MRI Control Room.jpg" },
  { id: 8, title: "Cath Lab Setup", category: "Installation", image: "/Cath Lab Setup.jpg" },
  { id: 9, title: "Medical Imaging Suite", category: "Facility", image: "/Medical Imaging Suite.jpg" },
];

export const GALLERY_CATEGORIES = ["All", "Equipment", "Installation", "Team", "Infrastructure", "Facility"];

export const FAQS = [
  {
    q: "Do you supply MRI scanners across India?",
    a: "Yes. MEDIS positions itself as a Pan-India medical imaging solutions company with equipment supply and support capability for hospitals and diagnostic centres.",
  },
  {
    q: "Do you provide CT scan systems for diagnostic centres?",
    a: "Yes. CT Scan Systems are listed as one of the core product categories within the MEDIS portfolio.",
  },
  {
    q: "Do you support installation and technical planning?",
    a: "Yes, MEDIS includes installation, technical services and site-related support as part of its end-to-end imaging ecosystem.",
  },
  {
    q: "Do you provide helium and cryogenic support?",
    a: "Yes, Helium Liquid & Gases, helium-related support, MRI magnet pre-cooling and cryogenic component services are all part of the broader offering.",
  },
  {
    q: "Do you provide spare parts and maintenance after purchase?",
    a: "Yes, Spare part support and structured maintenance offerings such as CMC / AMC are included in the MEDIS ecosystem.",
  },
  {
    q: "Do you support cath lab requirements as well?",
    a: "Yes, Cath Lab Systems are included in the MEDIS product portfolio and our support offering also extends to hospitals and cardiac care centres.",
  },
];

export const FOOTER_COLUMNS = [
  {
    title: "Products",
    items: [
      { label: "MRI Scanners", href: "#products" },
      { label: "CT Scan Systems", href: "#products" },
      { label: "Cath Lab Systems", href: "#products" },
      { label: "RF Shielding", href: "#products" },
      { label: "Helium & Cryogenic", href: "#products" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About Us", href: "#about" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Explore",
    items: [
      { label: "Dotmedixa", href: CONTACT.dotmedixa, external: true },
      { label: "Get a Quote", href: "#", modal: true },
    ],
  },
];
